// @flow
import classNames from 'classnames';
import * as React from 'react';
import BaseTypography from '@material-ui/core/Typography';

// Styles
import styles from './Typography.scss';

const VARIANT = {
  // Body
  CAPTION: 'caption',
  P: 'body1',
  // Headers
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  SUBTITLE: 'subtitle1',
};

type PropTypes = {
  children?: React.Node,
  className?: string,
  component?: string,
  variant?:
    | typeof VARIANT.CAPTION
    | typeof VARIANT.P
    | typeof VARIANT.H1
    | typeof VARIANT.H2
    | typeof VARIANT.H3
    | typeof VARIANT.H4
    | typeof VARIANT.H5
    | typeof VARIANT.H6
    | typeof VARIANT.SUBTITLE
};

const Typography = ({
  children,
  className,
  variant,
  ...props
}: PropTypes): React.Element<any> => (
  <BaseTypography
    {...props}
    variant={variant}
    className={classNames(className, styles.Root, {
      // Body
      [styles.RootVariantCaption]: variant === VARIANT.CAPTION,
      [styles.RootVariantP]: variant === VARIANT.P,
      // Headers
      [styles.RootVariantH1]: variant === VARIANT.H1,
      [styles.RootVariantH2]: variant === VARIANT.H2,
      [styles.RootVariantH3]: variant === VARIANT.H3,
      [styles.RootVariantH4]: variant === VARIANT.H4,
      [styles.RootVariantH5]: variant === VARIANT.H5,
      [styles.RootVariantH6]: variant === VARIANT.H6,
      [styles.RootVariantSubtitle]: variant === VARIANT.SUBTITLE,
    })}
  >
    {children}
  </BaseTypography>
);

// Exports
export default Typography;

export const Subtitle = (props: PropTypes) => (
  <Typography variant={VARIANT.SUBTITLE} {...props} />
);

export const Caption = (props: PropTypes) => (
  <Typography variant={VARIANT.CAPTION} {...props} />
);

export const P = (props: PropTypes) => (
  <Typography component="p" variant={VARIANT.P} {...props} />
);

export const H1 = (props: PropTypes) => (
  <Typography component="h1" variant={VARIANT.H1} {...props} />
);

export const H2 = (props: PropTypes) => (
  <Typography component="h2" variant={VARIANT.H2} {...props} />
);

export const H3 = (props: PropTypes) => (
  <Typography component="h3" variant={VARIANT.H3} {...props} />
);

export const H4 = (props: PropTypes) => (
  <Typography component="h4" variant={VARIANT.H4} {...props} />
);

export const H5 = (props: PropTypes) => (
  <Typography component="h5" variant={VARIANT.H5} {...props} />
);

export const H6 = (props: PropTypes) => (
  <Typography component="h6" variant={VARIANT.H6} {...props} />
);
